module.exports = __webpack_public_path__ + "img/tghd_img_bx2.07d8a8c3.png";